module.exports = [
 {
  "start": 41,
  "end": 4417,
  "text": "This two-channel video installation Ever is Over All is a modern fairytale"
 },
 {
  "start": 4542,
  "end": 7917,
  "text": " that is questioning obvious but actually illogical rules. "
 },
 {
  "start": 8083,
  "end": 14959,
  "text": "The red hot poker stick which symbolises here nature in the form of a Kniphophia plant is playing David, "
 },
 {
  "start": 15125,
  "end": 20000,
  "text": "and the civilisation with its environmental destruction is Goliath."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room2/audio2/02_2_MCA Ever Is Over All.js